module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"investors":"Investidores","cta":"Agende uma demonstração","privacyPolicy":"Política de Privacidade","TOS":"Termos e Condições Gerais de Uso","safety":"Segurança da Zazos"},"en":{"investors":"Investors","cta":"Try it out","privacyPolicy":"Privacy Policy","TOS":"Terms of Service","safety":"Zazos Safety"}}')
  delete Component.options._Ctor
}
